export const filterAllowedFiles = (files: File[]) => {
    const allowedExt = window.layoutExtensions ?? []
    const filteredFiles: File[] = []

    files.forEach(file => {
        const fileExt = file.name.split('.').pop()?.toLowerCase()
        if (fileExt && allowedExt.includes(fileExt)) {
            filteredFiles.push(file)
        }
    })

    return filteredFiles
}